import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import Modal from '../../components/ui/Modal';
import { Input } from '../../components/ui/Input';
import { feriasApi, funcionariosApi } from '../../api/rh';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

function formatarReais(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
function formatarData(d) {
  return d ? new Date(d + 'T00:00:00').toLocaleDateString('pt-BR') : '-';
}
function hojeISO() { return new Date().toISOString().slice(0, 10); }

const STATUS_LABEL = { pendente: 'Pendente', agendada: 'Agendada', gozada: 'Gozada', paga: 'Paga' };
const STATUS_TOM = { pendente: 'info', agendada: 'aviso', gozada: 'aviso', paga: 'sucesso' };

export default function FeriasList() {
  useTituloPagina('Férias');
  const [funcionarios, setFuncionarios] = useState([]);
  const [ferias, setFerias] = useState([]);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ dias_gozados: '30', dias_abono_pecuniario: '0', data_inicio_gozo: '', data_fim_gozo: '' });
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const carregar = () => {
    funcionariosApi.listar({ status: 'ativo' }).then(setFuncionarios).catch(() => {});
    feriasApi.listar().then(setFerias).catch(() => {});
  };
  useEffect(() => { carregar(); }, []);

  const periodoAberto = (funcionarioId) => ferias.find(f => f.funcionario_id === funcionarioId && ['pendente', 'agendada'].includes(f.status));

  const gerarPeriodo = async (funcionarioId) => {
    try {
      await feriasApi.gerar(funcionarioId);
      carregar();
    } catch (e) {
      alert(e.message);
    }
  };

  const abrirRegistro = (periodo) => {
    setForm({
      dias_gozados: String(periodo.dias_gozados || 30), dias_abono_pecuniario: String(periodo.dias_abono_pecuniario || 0),
      data_inicio_gozo: periodo.data_inicio_gozo || '', data_fim_gozo: periodo.data_fim_gozo || ''
    });
    setErro('');
    setEditando(periodo);
  };

  const salvar = async (status) => {
    setSalvando(true);
    setErro('');
    try {
      await feriasApi.atualizar(editando.id, {
        dias_gozados: form.dias_gozados, dias_abono_pecuniario: form.dias_abono_pecuniario,
        data_inicio_gozo: form.data_inicio_gozo || null, data_fim_gozo: form.data_fim_gozo || null,
        status, data_pagamento: status === 'paga' ? hojeISO() : null
      });
      setEditando(null);
      carregar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Funcionário</th>
              <th style={{ padding: 10 }}>Admissão</th>
              <th style={{ padding: 10 }}>Período Aquisitivo</th>
              <th style={{ padding: 10 }}>Status</th>
              <th style={{ padding: 10 }} />
            </tr>
          </thead>
          <tbody>
            {funcionarios.map(f => {
              const periodo = periodoAberto(f.id);
              const vencida = periodo && periodo.status === 'pendente' && periodo.periodo_aquisitivo_fim < hojeISO();
              return (
                <tr key={f.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                  <td style={{ padding: 10, fontWeight: 600 }}>{f.nome}</td>
                  <td style={{ padding: 10 }}>{formatarData(f.data_admissao)}</td>
                  <td style={{ padding: 10 }}>
                    {periodo ? `${formatarData(periodo.periodo_aquisitivo_inicio)} — ${formatarData(periodo.periodo_aquisitivo_fim)}` : '-'}
                  </td>
                  <td style={{ padding: 10 }}>
                    {periodo ? <Badge tom={vencida ? 'perigo' : STATUS_TOM[periodo.status]}>{vencida ? 'Vencida' : STATUS_LABEL[periodo.status]}</Badge> : '-'}
                  </td>
                  <td style={{ padding: 10 }}>
                    {!periodo && <Btn tamanho="sm" variante="secondary" onClick={() => gerarPeriodo(f.id)}>Gerar Período</Btn>}
                    {periodo && <Btn tamanho="sm" onClick={() => abrirRegistro(periodo)}>Registrar Gozo</Btn>}
                  </td>
                </tr>
              );
            })}
            {funcionarios.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum funcionário ativo.</td></tr>
            )}
          </tbody>
        </table>
      </Card>

      {editando && (
        <Modal titulo={`Registrar Férias — ${funcionarios.find(f => f.id === editando.funcionario_id)?.nome || ''}`} onFechar={() => setEditando(null)} largura={480}
          rodape={<>
            <Btn variante="ghost" onClick={() => setEditando(null)}>Cancelar</Btn>
            <Btn variante="secondary" onClick={() => salvar('agendada')} disabled={salvando}>Salvar como Agendada</Btn>
            <Btn onClick={() => salvar('paga')} disabled={salvando}>{salvando ? 'Salvando...' : 'Confirmar e Marcar como Paga'}</Btn>
          </>}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <p style={{ fontSize: 12, color: COLORS.textMid, margin: 0 }}>
              Direito total: {editando.dias_direito} dias. Até 1/3 ({Math.floor(editando.dias_direito / 3)} dias) pode virar abono pecuniário (vendido) em vez de gozado.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <Input label="Dias Gozados" type="number" min="0" max={editando.dias_direito} value={form.dias_gozados} onChange={e => setForm(f => ({ ...f, dias_gozados: e.target.value }))} />
              <Input label="Dias de Abono Pecuniário" type="number" min="0" max={Math.floor(editando.dias_direito / 3)} value={form.dias_abono_pecuniario} onChange={e => setForm(f => ({ ...f, dias_abono_pecuniario: e.target.value }))} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <Input label="Data de Início do Gozo" type="date" value={form.data_inicio_gozo} onChange={e => setForm(f => ({ ...f, data_inicio_gozo: e.target.value }))} />
              <Input label="Data de Fim do Gozo" type="date" value={form.data_fim_gozo} onChange={e => setForm(f => ({ ...f, data_fim_gozo: e.target.value }))} />
            </div>
            <div style={{ background: COLORS.primaryBg, borderRadius: 8, padding: 12 }}>
              <div style={{ fontSize: 11, color: COLORS.primary, fontWeight: 700, textTransform: 'uppercase' }}>Valor Estimado (com 1/3 constitucional)</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: COLORS.primary }}>
                {formatarReais((funcionarios.find(f => f.id === editando.funcionario_id)?.salario / 30) * (Number(form.dias_gozados) + Number(form.dias_abono_pecuniario)) * 4 / 3)}
              </div>
            </div>
            {erro && <p style={{ color: COLORS.danger, fontSize: 13, margin: 0 }}>{erro}</p>}
          </div>
        </Modal>
      )}
    </div>
  );
}
